import { get } from './client';

export function searchSeedCatalog(crop, searchTerm, year) {
  return get('/product-catalog/seeds', { params: { crop, searchTerm, year } });
}
